import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { fetchTopics, generateTopic } from "../lib/api";
import { useArchiveInvalidate } from "../lib/archive-events";

export const useTopicsList = ({ category, search, sort, limit }) => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchTopics({
        category: category && category !== "All" ? category : undefined,
        search: search || undefined,
        sort,
        limit,
      });
      setTopics(data);
    } catch {
      toast.error("Failed to load the archive. Try again shortly.");
    } finally {
      setLoading(false);
    }
  }, [category, search, sort, limit, setTopics, setLoading]);

  useEffect(() => { load(); }, [load]);
  useArchiveInvalidate(["topics", "submissions"], load);

  return { topics, loading, reload: load };
};

export const useTopicGeneration = () => {
  const [generating, setGenerating] = useState(false);

  const generate = async (title, category) => {
    setGenerating(true);
    try {
      const t = await generateTopic(title, category);
      return t;
    } finally {
      setGenerating(false);
    }
  };

  return { generating, generate };
};
